import { ListSubheader } from '@mui/material';
import React from 'react';
import styled from 'styled-components';
import { darkgrey, white } from 'styles/Colors';

export const IconWrapper = styled.div`
  svg {
    right: unset;
    top: unset;
    position: static;
  }
`;

export const AutocompleteWrapper = styled.div`
  &&& {
    .MuiFilledInput-root {
      height: 56px;
      max-height: 56px;
    }
    button {
      margin-right: 2px;
      margin-top: -2px;
      &:hover {
        background-color: transparent;
      }
    }
  }
`;

export const StyledListSubheader = styled((props) => <ListSubheader {...props} />)`
  &&& {
    color: ${darkgrey};
    font-feature-settings: 'liga' off;
    font-family: Lato;
    font-size: 11px;
    font-style: normal;
    font-weight: 700;
    line-height: 15.4px;
    padding: 8px;
    background-color: ${white};
    position: absolute;
    top: 0;
    width: calc(100% - 16px);
  }
`;
